import {parseResponse} from 'js-core/helpers/api'
import client from './client'

export default {
    async login(email, password, language) {
        let response = null

        try {
            response = await client.post(`/login`, {
                email: email,
                password: password,
            }, {
                headers: {
                    'X-Request-Language': language
                }
            })
        } catch (e) {
            response = e.response
        }
        return parseResponse(response)
    },
    async initiateAccountRecovery(email, language) {
        let response = null

        try {
            response = await client.post(`/user/account-recovery/initiate`, {
                email: email,
            }, {
                headers: {
                    'X-Request-Language': language
                }
            })
        } catch (e) {
            response = e.response
        }
        return parseResponse(response)
    },
    async checkAccountRecovery(hash, language) {
        let response = null

        try {
            response = await client.get(`/user/account-recovery/check`, {
                params: {
                    hash: hash
                }
            }, {
                headers: {
                    'X-Request-Language': language
                }
            })
        } catch (e) {
            response = e.response
        }
        return parseResponse(response)
    },
    async finishAccountRecovery(hash, password, language) {
        let response = null

        try {
            response = await client.post(`/user/account-recovery/finish`, {
                hash: hash,
                password: password
            },{
                headers: {
                    'X-Request-Language': language
                }
            })
        } catch (e) {
            response = e.response
        }

        return parseResponse(response)
    },
    async checkInvitationHash(hash, language) {
        let response = null

        try {
            response = await client.get(`/user/invite/check`, {
                params: {
                    hash: hash
                }
            }, {
                headers: {
                    'X-Request-Language': language
                }
            })
        } catch (e) {
            response = e.response
        }
        return parseResponse(response)
    },
    async confirmInvitation(hash, password, language) {
        let response = null

        try {
            response = await client.post(`/user/invite/confirm`, {
                hash: hash,
                password: password
            },{
                headers: {
                    'X-Request-Language': language
                }
            })
        } catch (e) {
            response = e.response
        }

        return parseResponse(response)
    },
}